<script>
import {useRoute} from "vue-router";
import {computed, onBeforeUnmount, onMounted, ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {useStore} from "vuex";
import Swal from "sweetalert2";
import router from "@/router";
import $ from "jquery";
import {Share} from '@capacitor/share';
import {Haptics, ImpactStyle} from "@capacitor/haptics";
import FreeWorld from "@/assets/js/FreeWorld";
import useClipboard from "vue-clipboard3";
import Swals from "@/assets/js/Swals";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";

export default {
  name: 'DetailsProducts',
  components: {NavbarPage, LoadingPage},

  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let store = useStore()
    let products = computed(() => store.state.order.products)

    let product_id = useRoute().params.prod_id
    let sub_cat_id = ref(useRoute().params.sub_cat_id)

    let counts = computed(() => store.state.order.orders_count)
    let price = computed(() => store.state.order.orders_price)

    let mark = ref(false)

    let loading = ref(false)

    let data_prod = ref(null)
    // let data_prodd = ref(null)

    let pics = ref([])

    let x = ref(false)
    if (products.value.length > 0) x.value = true

    let scroll = false
    onMounted(() => {
      scroll = true
    })
    onBeforeUnmount(() => {
      scroll = false
    })

    window.addEventListener('scroll', () => {
      const scrollPosition = window.scrollY;
      // اگر کاربر به پایین اسکرول کرده باشد، کلاس hidden اضافه شود، در غیر این صورت حذف شود
      if (scroll) {
        var navbar = document.getElementById('share_list')
        if (scrollPosition > 10) {
          if (navbar.style.height !== '25rem') {
            $("#img_share").removeClass('animate__fadeInUpBig');
            $("#img_share").addClass('animate__fadeOutDownBig');
          }

        } else {
          $("#img_share").removeClass('animate__fadeOutDownBig');
          $("#img_share").addClass('animate__fadeInUpBig');
        }
      }
    });

    function update_prod() {

      loading.value = true
      FreeWorld.Heisenberg({action: 'product', id: product_id}, 'Element').then((result) => {

        loading.value = false

        data_prod.value = result.data
        data_prod.value.order_count_select = 0
        data_prod.value.type = 'product'
        if (data_prod.value.is_variable === 1) {
          data_prod.value.variable_item.forEach((item) => {
            item.order_count_select = 0
            item.type = 'product'
            item.off_price = null
            item.price = +item.price
            item.variable_id = item.id
            delete item.id
          })
        }
        change_prods()

      }).catch((result) => {

        loading.value = false
        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
          }).then((result) => {
            if (result.isConfirmed) {
              update_prod()
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
          }).then((result) => {
            if (result.isConfirmed) {
              update_prod()
            }
          })
        }
      })
    }

    update_prod()

    function change_prods() {

      data_prod.value.is_variable > 0 ? products.value.forEach((item) => {
        let found = data_prod.value.variable_item.find(find_item => item.variable_id === find_item.variable_id)
        if (found) {
          found.order_count_select = item.order_count_select
        }
      }) : products.value.forEach((item) => {
        if (data_prod.value.id == item.id && data_prod.value.type === 'product') {

          if (data_prod.value.count != -1 && item.order_count_select > data_prod.value.count) {
            data_prod.value.order_count_select = data_prod.value.count
            store.commit('ProductUpdate', data_prod.value)
          } else if (data_prod.value.count == 0) {
            data_prod.value.order_count_select = 0
            store.commit('ProductUpdate', data_prod.value)
          } else {
            data_prod.value.order_count_select = item.order_count_select
          }
          return false
        }
      })

      // products.value = store.state.order.products
      // counts.value = store.state.order.orders_count
      // price.value = store.state.order.orders_price
      products.value.length > 0 ? x.value = true : x.value = false

      if (data_prod.value.marke != 0) {
        mark.value = true
      } else {
        mark.value = false
      }

      if (data_prod.value.pic1 != null) {
        pics.value.push(data_prod.value.pic1)
      }
      if (data_prod.value.pic2 != null) {
        pics.value.push(data_prod.value.pic2)
      }
      if (data_prod.value.pic3 != null) {
        pics.value.push(data_prod.value.pic3)
      }
      if (data_prod.value.pic4 != null) {
        pics.value.push(data_prod.value.pic4)
      }

    }

    function share_list() {

      let navbar = document.getElementById('share_list')
      let img_navbar = document.getElementById('up_share_list_img')

      if (navbar.style.height === '25rem') {
        navbar.style.height = '0px'
        img_navbar.classList.toggle("clicked");
      } else {
        navbar.style.height = '25rem'
        img_navbar.classList.toggle("clicked")
      }
    }

    function mark_prod() {

      let div_mark = document.getElementById('div_mark')

      div_mark.style.pointerEvents = 'none'
      mark.value = !mark.value

      let data = {
        action: 'add',
        sub_cat: sub_cat_id.value,
        item_id: product_id,
        type: 'product',
      }

      FreeWorld.Heisenberg(data, 'user_marke', true).then((result) => {
        let res = result.data

        setTimeout(() => {
          if (res.event == 'mark delete') {
            mark.value = false
          } else if (res.event == 'mark add') {
            mark.value = true
          }
          div_mark.style.pointerEvents = 'auto'
        }, 1000)

      }).catch(() => {

        setTimeout(() => {
          mark.value = !mark.value
          div_mark.style.pointerEvents = 'auto'
        }, 1000)

        console.log('don`t mark')
      })


    }

    let show_variable = ref({
      index: null,
      action: false,
    })

    function show_pic(index) {

      if (index) {
        show_variable.value.index = index - 1
        show_variable.value.action = true
      } else {
        show_variable.value.action = false
        show_variable.value.index = null
      }

    }

    const {toClipboard} = useClipboard()

    async function call_unit() {
      let phone_support = data_prod.value.phone_store
      await Swals.Dialog(phone_support, null, 'کپی کردن', 'انصراف').then(async (res) => {
        if (res.isConfirmed) {
          try {
            await toClipboard(phone_support)
            await Swals.Done('شماره پشتیبانی با موفقیت کپی شد');
          } catch (e) {
            console.log(e.message)
            await Swals.Fault('متاسفانه شماره پشتیبانی کپی نشد!');
          }
        }
      });
    }

    function share_prod() {
      Share.share({
        title: data_prod.value.name,
        text: 'اپلیکیشن دکوبان',
        url: 'https://decoban.ir',
        dialogTitle: 'اشتراک گذاری برای دیگران',
      });
    }

    const txtoverflow = document.querySelectorAll('.txtoverflow');

    function startAnimation() {
      txtoverflow.forEach(element => {
        element.classList.add('animate');
      });
    }

    function stopAnimation() {
      txtoverflow.forEach(element => {
        element.classList.remove('animate');
      });
    }

    txtoverflow.forEach(element => {
      element.addEventListener('animationstart', startAnimation);
      element.addEventListener('animationend', stopAnimation);
    });


    function UpdateProduct(name) {

      if (data_prod.value.order_count_select < 0 || !data_prod.value.order_count_select) data_prod.value.order_count_select = 0

      // let check_products = store.state.order.products
      // products.value = store.state.order.products

      if (products.value.length === 0) {

        x.value = true
        data_prod.value.order_count_select++
        store.commit('ProductUpdate', data_prod.value)
        // products.value = store.state.order.products
        // counts.value = store.state.order.orders_count
        // price.value = store.state.order.orders_price


      } else if (products.value.length > 0 && name) {

        products.value.forEach((item) => {

          if (item.type !== 'product') {

            Swal.fire({
              title: "!...متاسفم",
              text: "در حال حاضر دوره های آموزشی در سبد خرید شما وجود دارد!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#28a745",
              cancelButtonColor: "#d33",
              confirmButtonText: "ساخت سبد خرید جدید",
              cancelButtonText: "انصراف",
              showClass: {
                popup: 'animate__animated animate__bounceInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__bounceOutUp'
              }
            }).then((result) => {

              if (result.isConfirmed) {


                Swal.fire({
                  text: "!با ساختن سبد خرید جدید سبد خرید قبلی شما حذف خواهد شد",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#28a745",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "متوجه شدم",
                  cancelButtonText: "انصراف",
                  showClass: {
                    popup: 'animate__animated animate__bounceInDown'
                  },
                  hideClass: {
                    popup: 'animate__animated animate__bounceOutUp'
                  }
                }).then((result) => {
                  if (result.isConfirmed) {

                    store.commit('EmptyBasket')
                    data_prod.value.order_count_select++
                    store.commit('ProductUpdate', data_prod.value)
                    x.value = true
                    products.value = store.state.order.products
                    counts.value = store.state.order.orders_count
                    price.value = store.state.order.orders_price

                    Swal.fire({
                      text: "سبد خرید جدید شما با موفقیت ایجاد شد",
                      confirmButtonText: "متوجه شدم",
                      icon: "success"
                    });
                  }
                });
              }
            });

            return false

          } else if (item.name_store !== name) {

            Swal.fire({
              title: "!...متاسفم",
              text: "!شما فقط میتوانید از یک فروشگاه خرید انجام دهید",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#28a745",
              cancelButtonColor: "#d33",
              confirmButtonText: "ساخت سبد خرید جدید",
              cancelButtonText: "انصراف",
              showClass: {
                popup: 'animate__animated animate__bounceInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__bounceOutUp'
              }
            }).then((result) => {

              if (result.isConfirmed) {

                Swal.fire({
                  text: "!با ساختن سبد خرید جدید سبد خرید قبلی شما حذف خواهد شد",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#28a745",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "متوجه شدم",
                  cancelButtonText: "انصراف",
                  showClass: {
                    popup: 'animate__animated animate__bounceInDown'
                  },
                  hideClass: {
                    popup: 'animate__animated animate__bounceOutUp'
                  }
                }).then((result) => {
                  if (result.isConfirmed) {

                    store.commit('EmptyBasket')
                    data_prod.value.order_count_select++
                    store.commit('ProductUpdate', data_prod.value)
                    x.value = true
                    // products.value = store.state.order.products
                    // counts.value = store.state.order.orders_count
                    // price.value = store.state.order.orders_price

                    Swal.fire({
                      text: "سبد خرید جدید شما با موفقیت ایجاد شد",
                      confirmButtonText: "متوجه شدم",
                      icon: "success"
                    });
                  }
                });
              }
            });

            return false

          } else {

            store.commit('ProductUpdate', data_prod.value)
            // products.value = store.state.order.products
            // counts.value = store.state.order.orders_count
            // price.value = store.state.order.orders_price

            if (products.value.length == 0) {
              $("#orders").addClass('animate__animated animate__fadeOutDown')
              setTimeout(() => {
                x.value = false
              }, 1000)
            }

            return false
          }

        })

      } else {

        store.commit('ProductUpdate', data_prod.value)
        // products.value = store.state.order.products
        // counts.value = store.state.order.orders_count
        // price.value = store.state.order.orders_price

        if (products.value.length == 0) {

          $("#orders").addClass('animate__animated animate__fadeOutDown')


          setTimeout(() => {
            x.value = false
          }, 1000)

        }
      }
    }

    function UpdateProduct_variable(id) {

      // products.value = store.state.order.products
      let option = new Object(data_prod.value.variable_item.find(item => item.variable_id === id))

      if (option.order_count_select < 0 || !option.order_count_select) option.order_count_select = 0

      if (products.value.length === 0) {

        option.order_count_select++
        option.name = `${data_prod.value.name} با کد ${option.code}`
        option.name_store = data_prod.value.name_store
        option.is_variable = data_prod.value.is_variable
        option.unit_id = data_prod.value.unit_id
        option.installer = data_prod.value.installer
        option.id = data_prod.value.id
        option.pic1 = option.pic
        store.commit('ProductUpdate', option)
        // products.value = store.state.order.products
        // counts.value = store.state.order.orders_count
        // price.value = store.state.order.orders_price

      } else {

        let find = products.value.find(item => {
          if (item.type !== 'product') {
            Swal.fire({
              title: "!...متاسفم",
              text: "در حال حاضر دوره های آموزشی در سبد خرید شما وجود دارد!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#28a745",
              cancelButtonColor: "#d33",
              confirmButtonText: "ساخت سبد خرید جدید",
              cancelButtonText: "انصراف",
              showClass: {
                popup: 'animate__animated animate__bounceInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__bounceOutUp'
              }
            }).then((result) => {

              if (result.isConfirmed) {

                Swal.fire({
                  text: "!با ساختن سبد خرید جدید سبد خرید قبلی شما حذف خواهد شد",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#28a745",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "متوجه شدم",
                  cancelButtonText: "انصراف",
                  showClass: {
                    popup: 'animate__animated animate__bounceInDown'
                  },
                  hideClass: {
                    popup: 'animate__animated animate__bounceOutUp'
                  }
                }).then((result) => {
                  if (result.isConfirmed) {

                    store.commit('EmptyBasket')
                    option.order_count_select++
                    option.name = `${data_prod.value.name} با کد ${option.code}`
                    option.name_store = data_prod.value.name_store
                    option.is_variable = data_prod.value.is_variable
                    option.unit_id = data_prod.value.unit_id
                    option.installer = data_prod.value.installer
                    option.id = data_prod.value.id
                    option.pic1 = option.pic
                    store.commit('ProductUpdate', option)
                    // products.value = store.state.order.products
                    // counts.value = store.state.order.orders_count
                    // price.value = store.state.order.orders_price

                    Swal.fire({
                      text: "سبد خرید جدید شما با موفقیت ایجاد شد",
                      confirmButtonText: "متوجه شدم",
                      icon: "success"
                    });
                    return false
                  }
                });
              }
            });
          } else if (item.unit_id !== data_prod.value.unit_id) {
            Swal.fire({
              title: "!...متاسفم",
              text: "!شما فقط میتوانید از یک فروشگاه خرید انجام دهید",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#28a745",
              cancelButtonColor: "#d33",
              confirmButtonText: "ساخت سبد خرید جدید",
              cancelButtonText: "انصراف",
              showClass: {
                popup: 'animate__animated animate__bounceInDown'
              },
              hideClass: {
                popup: 'animate__animated animate__bounceOutUp'
              }
            }).then((result) => {

              if (result.isConfirmed) {

                Swal.fire({
                  text: "!با ساختن سبد خرید جدید سبد خرید قبلی شما حذف خواهد شد",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#28a745",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "متوجه شدم",
                  cancelButtonText: "انصراف",
                  showClass: {
                    popup: 'animate__animated animate__bounceInDown'
                  },
                  hideClass: {
                    popup: 'animate__animated animate__bounceOutUp'
                  }
                }).then((result) => {
                  if (result.isConfirmed) {

                    store.commit('EmptyBasket')
                    option.order_count_select++
                    option.name = `${data_prod.value.name} با کد ${option.code}`
                    option.name_store = data_prod.value.name_store
                    option.is_variable = data_prod.value.is_variable
                    option.unit_id = data_prod.value.unit_id
                    option.installer = data_prod.value.installer
                    option.id = data_prod.value.id
                    option.pic1 = option.pic
                    store.commit('ProductUpdate', option)
                    // products.value = store.state.order.products
                    // counts.value = store.state.order.orders_count
                    // price.value = store.state.order.orders_price

                    Swal.fire({
                      text: "سبد خرید جدید شما با موفقیت ایجاد شد",
                      confirmButtonText: "متوجه شدم",
                      icon: "success"
                    });
                    return false
                  }
                });
              }
            });
          } else {
            return true
          }
        })

        if (find) {
          option.name = `${data_prod.value.name} با کد ${option.code}`
          option.name_store = data_prod.value.name_store
          option.is_variable = data_prod.value.is_variable
          option.unit_id = data_prod.value.unit_id
          option.installer = data_prod.value.installer
          option.id = data_prod.value.id
          option.pic1 = option.pic
          store.commit('ProductUpdate', option)
          // products.value = store.state.order.products
          // counts.value = store.state.order.orders_count
          // price.value = store.state.order.orders_price
        }


        // products.value.forEach((item) => {
        //
        //   if (item.type !== 'product') {
        //     console.log('xxx')
        //
        //     Swal.fire({
        //       title: "!...متاسفم",
        //       text: "در حال حاضر دوره های آموزشی در سبد خرید شما وجود دارد!",
        //       icon: "warning",
        //       showCancelButton: true,
        //       confirmButtonColor: "#28a745",
        //       cancelButtonColor: "#d33",
        //       confirmButtonText: "ساخت سبد خرید جدید",
        //       cancelButtonText: "انصراف",
        //       showClass: {
        //         popup: 'animate__animated animate__bounceInDown'
        //       },
        //       hideClass: {
        //         popup: 'animate__animated animate__bounceOutUp'
        //       }
        //     }).then((result) => {
        //
        //       if (result.isConfirmed) {
        //
        //         Swal.fire({
        //           text: "!با ساختن سبد خرید جدید سبد خرید قبلی شما حذف خواهد شد",
        //           icon: "warning",
        //           showCancelButton: true,
        //           confirmButtonColor: "#28a745",
        //           cancelButtonColor: "#d33",
        //           confirmButtonText: "متوجه شدم",
        //           cancelButtonText: "انصراف",
        //           showClass: {
        //             popup: 'animate__animated animate__bounceInDown'
        //           },
        //           hideClass: {
        //             popup: 'animate__animated animate__bounceOutUp'
        //           }
        //         }).then((result) => {
        //           if (result.isConfirmed) {
        //
        //             store.commit('EmptyBasket')
        //             option.order_count_select++
        //             option.name = `${data_prod.value.name} با کد ${option.code}`
        //             option.name_store = data_prod.value.name_store
        //             option.is_variable = data_prod.value.is_variable
        //             option.unit_id = data_prod.value.unit_id
        //             option.installer = data_prod.value.installer
        //             option.id = data_prod.value.id
        //             option.pic1 = option.pic
        //             store.commit('ProductUpdate', option)
        //             products.value = store.state.order.products
        //             counts.value = store.state.order.orders_count
        //             price.value = store.state.order.orders_price
        //
        //             Swal.fire({
        //               text: "سبد خرید جدید شما با موفقیت ایجاد شد",
        //               confirmButtonText: "متوجه شدم",
        //               icon: "success"
        //             });
        //           }
        //         });
        //       }
        //     });
        //
        //   } else if (item.unit_id !== data_prod.value.unit_id) {
        //
        //     console.log('nnn')
        //     Swal.fire({
        //       title: "!...متاسفم",
        //       text: "!شما فقط میتوانید از یک فروشگاه خرید انجام دهید",
        //       icon: "warning",
        //       showCancelButton: true,
        //       confirmButtonColor: "#28a745",
        //       cancelButtonColor: "#d33",
        //       confirmButtonText: "ساخت سبد خرید جدید",
        //       cancelButtonText: "انصراف",
        //       showClass: {
        //         popup: 'animate__animated animate__bounceInDown'
        //       },
        //       hideClass: {
        //         popup: 'animate__animated animate__bounceOutUp'
        //       }
        //     }).then((result) => {
        //
        //       if (result.isConfirmed) {
        //
        //         Swal.fire({
        //           text: "!با ساختن سبد خرید جدید سبد خرید قبلی شما حذف خواهد شد",
        //           icon: "warning",
        //           showCancelButton: true,
        //           confirmButtonColor: "#28a745",
        //           cancelButtonColor: "#d33",
        //           confirmButtonText: "متوجه شدم",
        //           cancelButtonText: "انصراف",
        //           showClass: {
        //             popup: 'animate__animated animate__bounceInDown'
        //           },
        //           hideClass: {
        //             popup: 'animate__animated animate__bounceOutUp'
        //           }
        //         }).then((result) => {
        //           if (result.isConfirmed) {
        //
        //             store.commit('EmptyBasket')
        //             option.order_count_select++
        //             option.name = `${data_prod.value.name} با کد ${option.code}`
        //             option.name_store = data_prod.value.name_store
        //             option.is_variable = data_prod.value.is_variable
        //             option.unit_id = data_prod.value.unit_id
        //             option.installer = data_prod.value.installer
        //             option.id = data_prod.value.id
        //             option.pic1 = option.pic
        //             store.commit('ProductUpdate', option)
        //             products.value = store.state.order.products
        //             counts.value = store.state.order.orders_count
        //             price.value = store.state.order.orders_price
        //
        //             Swal.fire({
        //               text: "سبد خرید جدید شما با موفقیت ایجاد شد",
        //               confirmButtonText: "متوجه شدم",
        //               icon: "success"
        //             });
        //           }
        //         });
        //       }
        //     });
        //
        //   } else {
        //     console.log('lll')
        //     option.name = `${data_prod.value.name} با کد ${option.code}`
        //     option.name_store = data_prod.value.name_store
        //     option.is_variable = data_prod.value.is_variable
        //     option.unit_id = data_prod.value.unit_id
        //     option.installer = data_prod.value.installer
        //     option.id = data_prod.value.id
        //     option.pic1 = option.pic
        //     store.commit('ProductUpdate', option)
        //     products.value = store.state.order.products
        //     counts.value = store.state.order.orders_count
        //     price.value = store.state.order.orders_price
        //   }
        //
        // })

      }


      if (products.value.length === 0) {

        $("#orders").addClass('animate__animated animate__fadeOutDown')

        setTimeout(() => {
          x.value = false
        }, 1000)

      } else {
        x.value = true
      }

    }

    function alerts(action) {

      Haptics.impact({style: ImpactStyle.Light});
      Haptics.vibrate();

      if (action == 'End of inventory') {

        Swal.fire({
          text: "موجودی محصول به اتمام رسید!",
          showCancelButton: false,
          confirmButtonText: "متوجه شدم",
          showClass: {
            popup: 'animate__animated animate__bounceInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__bounceOutUp'
          }
        })

      }

    }

    function comparison() {

      store.commit('set_comparison_products', data_prod.value)
      router.push({
        name: 'ComparisonProducts',
        params: {prod_id_one: product_id, prod_id_two: '0', sub_cat_id: sub_cat_id.value}
      })

    }

    return {
      loading,
      data_prod,
      pics,
      share_list,
      product_id,
      mark_prod,
      mark,
      sub_cat_id,
      UpdateProduct,
      products,
      price,
      counts,
      alerts,
      comparison,
      share_prod,
      call_unit,
      x,
      UpdateProduct_variable,
      show_variable,
      show_pic,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div v-if="show_variable.action" @click="show_pic(false)" class="alert">
    <img class="w-100" :src="data_prod.variable_item[show_variable.index].pic" alt="">
  </div>


  <div id="main" :class="loading ? 'activeClass' : '' " class="bg-main" dir="ltr">
    <div class="div-top-arrow bg-color d-flex align-items-center ">

      <p class="m-0">
        فروشگاه
      </p>
      <div onclick="window.history.back()">
        <img class="svg-arrow" src="../assets/img/back.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>
    <div v-if="data_prod != null" class="p-body">
      <div class="">
        <div class="div_img_products rounded-4 my-3">

          <img v-if="pics.length === 0" class="w-100 h-100 rounded-4" src="../assets/img/img-notavalible.jpg"
               alt="">

          <v-carousel v-else
                      class="div_img_products rounded-4 "
                      :show-arrows="false"
                      hide-delimiter-background>
            <v-carousel-item
                v-for="pic in pics"
                :key="pic.index"
                class="img_products "
                :src="pic"

            ></v-carousel-item>
          </v-carousel>
        </div>


        <div class=" mb-2">
          <div class="d-flex p-3 bg-white rounded-4 border-costom align-items-center"
               :class="data_prod.is_variable === 0 ? 'justify-content-between':'justify-content-end'">

            <div v-if="data_prod.is_variable === 0" class="w-33">
              <div v-if="data_prod.count == 0 " class="bg-unavailable rounded-5 d-flex p-2 align-items-center">
                <img style="width: 1.5rem" class="mx-2" src="../assets/img/add-to-cart.svg" alt="">
                <p class="text-white font-5 px-2 m-0">
                  ناموجود
                </p>
              </div>

              <div style="height: 3rem;" v-else-if="data_prod.order_count_select < 1"
                   @click="UpdateProduct(data_prod.name_store)"
                   class="bg-green rounded-5 d-flex p-2 align-items-center justify-center">
                <img style="width: 1.5rem" class="mx-2" src="../assets/img/add-to-cart.svg" alt="">
                <p class="text-white font-4 px-2 m-0">
                  خرید
                </p>
              </div>

              <div style="height: 3.5rem" v-else-if="data_prod.order_count_select > 0"
                   class="d-flex py-2 px-3 rounded-pill justify-content-between align-items-center border-costom">
                <img style="width: 1.5rem" class="svg_inventory" src="../assets/img/minus.svg" alt=""
                     @click="data_prod.order_count_select-- ;UpdateProduct()">

                <p class="m-0 font-3">
                  <input class="w-100 ma-auto text-center" type="number" :value="data_prod.order_count_select"
                     @focusout="(event)=>{data_prod.order_count_select = Number(event.target.value) ; UpdateProduct()}">
                </p>

                <img style="width: 1.5rem" class="svg_inventory" src="../assets/img/add_green.svg" alt=""
                     v-if="data_prod.count == -1 "
                     @click="data_prod.order_count_select++ ;UpdateProduct()">

                <img style="width: 1.5rem" class="svg_inventory" src="../assets/img/add_green.svg" alt=""
                     @click="data_prod.order_count_select++ ;UpdateProduct()"
                     v-else-if="data_prod.order_count_select < data_prod.count">

                <img style="width: 1.5rem" class="svg_inventory" src="../assets/img/add_green.svg" alt=""
                     v-else
                     @click="alerts('End of inventory')">
              </div>
            </div>

            <div class="overflow-hidden" :class="data_prod.is_variable === 0 ? 'w-70':'w-100'">
              <p :class="data_prod.name.length > 30 ? 'txtoverflow' : '' "
                 class="m-0 d-flex justify-content-end font-bold text-end font-4">{{ data_prod.name }}</p>
            </div>
          </div>
        </div>

        <div class=" mb-2">
          <div class="d-flex p-3 bg-white rounded-4 border-costom  justify-content-between align-items-center">

            <div class="d-flex ">
              <div v-if="data_prod.rating_product != null"
                   class="d-flex align-items-center bg-costom rounded-pill px-3 py-2">
                <img style="width:1.5rem" src="../assets/img/star_gold.svg" alt="">

                <p class="m-0 font-5 mx-2">
                  {{ data_prod.rating_product }}
                </p>
              </div>

              <div v-if="data_prod.off_price != null"
                   class="d-flex align-items-center bg-costom rounded-pill mx-1 px-1 py-2">

                <p class="m-0 mx-2 font-5 font-color">
                  <span>{{ data_prod.discount }}</span>
                  <span>%</span>
                </p>
              </div>
            </div>
            <div class="d-flex ">
              <p v-if="data_prod.off_price != null " class="d-flex font-color font-4 mx-3 m-0">
                <span>تومان</span>
                &nbsp;
                <span>{{ data_prod.off_price.toLocaleString() }}</span>
              </p>

              <p :class="data_prod.off_price == null ? 'font-color' : 'text-decoration-line-through' "
                 class="font-4 m-0 d-flex">
                <span v-if="data_prod.off_price == null">تومان</span>
                &nbsp;
                {{ data_prod.price.toLocaleString() }}
              </p>
            </div>
          </div>
        </div>

        <div class="w-100 mb-2">
          <div class="p-3 bg-white rounded-4 border-costom d-flex align-items-center justify-content-between">

            <router-link :to="{name:'StorePage',params:{unit_id:data_prod.unit_id}}"
                         class="m-0 font-color text-decoration-none font-5">
              مشاهده فروشگاه
            </router-link>

            <div style="max-width: 50%" class="d-flex justify-content-end align-items-center my-1">
              <div v-if="data_prod.rating_store != null " class="position-relative">
                <img style="height: 1.5rem" src="../assets/img/star_gold.svg" alt="">
                <p class="position-absolute m-0 font-5 text-white number_star">
                  {{ data_prod.rating_store }}
                </p>
              </div>
              <div class="d-flex justify-content-end w-100">
                <div class="overflow-hidden">
                  <p class="font-4 mx-2 m-0 d-flex" :class="data_prod.name_store.length >= 25 ? 'txtoverflow' : '' ">
                    {{ data_prod.name_store }}</p>
                </div>
                <img style="width: 1.5rem" class="ml-1" src="../assets/img/shop.svg" alt="">
              </div>
            </div>
          </div>
        </div>

        <div class=" mb-2">
          <div class="d-flex flex-column p-3 bg-white rounded-4 border-costom align-items-center">
            <p class="font-4 text-end w-100">
              :توضیحات محصول
            </p>
            <div class="w-100" dir="rtl">
              <p class="font-5 w-100 m-0">{{ data_prod.info }}</p>
            </div>

          </div>
        </div>

        <div v-if="data_prod.options.length != 0" class=" mb-2">
          <div class="p-3 bg-white rounded-4 border-costom">
            <div v-for="item in data_prod.options" :key="item.id" class="">
              <div class="d-flex justify-content-between p-1 ">
                <p class="d-flex font-5 m-0">
                  {{ item.value }}
                </p>
                <p class="font-5 font-bold m-0">
                  : {{ item.option_name }}
                </p>
              </div>
              <hr>
            </div>

          </div>
        </div>

        <div v-if="data_prod.pdf_file != null " class=" mb-2">
          <div class="d-flex align-items-center justify-content-center bg-white rounded-4 px-2 py-4 position-relative">
            <a :href="data_prod.pdf_file" target="_blank" class="font-3 m-0 font-color font-bold text-decoration-none">
              محصول PDF دانلود
            </a>
            <img style="right:0;width: 4.5rem;height: 3.1rem" class="rounded-4 position-absolute"
                 src="../assets/img/download_icon.svg" alt="">
          </div>
        </div>
        <div v-if="data_prod.watch_link != null " class=" mb-2">
          <div class="d-flex align-items-center  justify-content-center bg-white rounded-4 px-2 py-4 position-relative">
            <a :href="data_prod.watch_link" target="_blank"
               class="font-3 m-0 font-color font-bold text-decoration-none">
              مشاهده ویدئو
            </a>
            <img style="right:0;width: 4.5rem;height: 3.1rem" class="rounded-4 position-absolute"
                 src="../assets/img/play_video.svg" alt="">
          </div>
        </div>
      </div>

      <div v-if="data_prod.is_variable" class="">
        <table class="w-100 text-center bg-white rounded-4">
          <thead class="font-4 bg-warning-subtle">
          <tr style="height: 3rem">
            <th>انتخاب</th>
            <th>قیمت</th>
            <th>کد محصول</th>
            <th>عکس</th>
          </tr>
          </thead>

          <tbody class="font-5">
          <tr v-for="(item , index) in data_prod.variable_item" :key="item.id" class="border-bottom"
              style="height: 5rem">
            <td style="max-width: 8rem">
              <div v-if="item.count === 0 " class="bg-unavailable ms-2 w-80 rounded-5 d-flex p-2 align-items-center">
                <img style="width: 1.5rem" class="mx-2" src="../assets/img/add-to-cart.svg" alt="">
                <p class="text-white font-5 px-2 m-0">
                  ناموجود
                </p>
              </div>

              <div v-else-if="item.order_count_select < 1"
                   @click="UpdateProduct_variable(item.variable_id)"
                   class="bg-green rounded-5 d-flex p-2 align-items-center justify-center ms-2 w-80">
                <img style="width: 1.5rem" class="mx-2" src="../assets/img/add-to-cart.svg" alt="">
                <p class="text-white font-5 px-2 m-0">
                  خرید
                </p>
              </div>

              <div v-else-if="item.order_count_select > 0"
                   class="w-80 ms-2 d-flex py-2 px-3 rounded-pill justify-content-between border-costom">
                <img style="width: 1.5rem" class="svg_inventory" src="../assets/img/minus.svg" alt=""
                     @click="item.order_count_select--;UpdateProduct_variable(item.variable_id)">

                <input type="number" class="font-4 w-100 text-center" :value="item.order_count_select"
                       @focusout="(event)=>{item.order_count_select = Number(event.target.value) ; UpdateProduct_variable(item.variable_id)}">

                <img style="width: 1.5rem" class="svg_inventory" src="../assets/img/add_green.svg" alt=""
                     @click="item.order_count_select++ ;UpdateProduct_variable(item.variable_id)"
                     v-if="item.order_count_select < item.count">

                <img style="width: 1.5rem" class="svg_inventory" src="../assets/img/add_green.svg" alt=""
                     v-else
                     @click="alerts('End of inventory')">
              </div>
            </td>
            <td class="font-3">{{ Number(item.price).toLocaleString() }}</td>
            <td class="font-3">{{ item.code }}</td>
            <td><img @click="show_pic(index + 1)" class="img_variable rounded-3" :src="item.pic" alt=""></td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="div_share z-3">

        <div id="img_share" @click="share_list" class="holder_navbar_share z-5 animate__animated animate__fadeInUpBig">
          <img style="width: 4rem" id="up_share_list_img" src="../assets/img/up_down.svg" alt="">
        </div>
        <div id="share_list" class="share_list d-flex flex-column bg-color px-1 align-items-center">

          <div @click="share_prod" class="d-flex flex-column align-items-center mb-2 pt-4 px-2">
            <img style="width: 1.5rem" src="../assets/img/share.svg" alt="">
            <p class="m-0 font-7 text-white text-center my-2">
              اشتراک گذاری
            </p>
          </div>

          <div id="div_mark" @click="mark_prod" class="d-flex flex-column align-items-center mb-2 px-2">
            <img v-if="mark" style="width: 1.5rem" src="../assets/img/save_mark.svg" alt="">
            <img v-else style="width: 1.5rem" src="../assets/img/bookmark-white.svg" alt="">
            <p class="m-0 font-7 text-white text-center my-2">
              نشان کردن
            </p>
          </div>

          <router-link :to="{name:'CommentProducts',params:{prod_id:product_id , type:'product'}}"
                       class="d-flex flex-column text-decoration-none align-items-center mb-2 px-2">
            <img style="width: 1.5rem" src="../assets/img/comment.svg" alt="">
            <p class="m-0 font-7 text-white text-center my-2">
              نظرات محصول
            </p>
          </router-link>

          <!--          <div @click="call_unit" class="d-flex flex-column align-items-center mb-2 px-2">-->
          <!--            <img style="width: 1.5rem" src="../assets/img/telephone.svg" alt="">-->
          <!--            <p class="m-0 font-7 text-white text-center my-2">-->
          <!--              تماس با فروشنده-->
          <!--            </p>-->
          <!--          </div>-->

          <!--          <router-link :to="{name:'UnitChat',params:{chat_id:data_prod.unit_id}}"-->
          <!--                       class="d-flex flex-column text-decoration-none align-items-center mb-2 px-2">-->
          <!--            <img style="width: 1.5rem" src="../assets/img/chat.svg" alt="">-->
          <!--            <p class="m-0 font-7 text-white text-center my-2">-->
          <!--              چت با فروشنده-->
          <!--            </p>-->
          <!--          </router-link>-->

          <div @click="comparison"
               class="d-flex flex-column text-decoration-none align-items-center mb-2 mb-5 px-2">
            <img style="width: 1.5rem" src="../assets/img/change.svg" alt="">
            <p class="m-0 font-7 text-white text-center my-2">
              مقایسه محصول
            </p>
          </div>
        </div>
      </div>

    </div>
    <br>

    <div v-if="x">

      <br>
      <br>
      <br>
      <div id="orders" class="p-body div_orders animate__animated animate__fadeInUp">

        <div class="h-100 rounded-pill shadow-costom bg-white d-flex align-items-center justify-content-between px-2">
          <div>
            <router-link :to="{name:'OrdersPage'}"
                         class="d-flex font-4 p-3 bg-color rounded-pill text-decoration-none align-items-center border-costom text-white">
              <img style="width:1.5rem" class="mx-2" src="../assets/img/shopping-bag.svg" alt="">

              <p class="m-0">
                مشاهده سبد خرید
              </p>
            </router-link>
          </div>
          <div>
            <p class="m-0 d-flex font-4 justify-content-end">
              <span>تومان</span>
              <span class="font-bold mx-2">{{ price.toLocaleString() }}</span>
            </p>
            <p class="m-0 d-flex font-4 justify-content-end">
              <span>.قلم سفارش داده اید</span>
              <span class="font-bold mx-2">{{ counts }}</span>
            </p>
          </div>
        </div>
      </div>

    </div>


  </div>

  <div id="web" :class="loading ? 'activeClass' : '' " class="bg-main">
    <NavbarPage></NavbarPage>

    <div v-if="data_prod != null" class="d-flex position-relative">
      <div style="left:0" class="w-85 position-absolute">
        <div class="w-90 p-body">
          <div class="animate__animated animate__fadeIn">
            <div class="d-flex justify-space-between mb-7">
              <div style="width: 15rem;height: 15rem" class="rounded-4 my-3">

                <img v-if="pics.length == 0" class="w-100 h-100 rounded-4" src="../assets/img/img-notavalible.jpg"
                     alt="">

                <v-carousel v-else
                            class="w-100 h-100 rounded-4 "
                            :show-arrows="false"
                            hide-delimiter-background>
                  <v-carousel-item
                      v-for="pic in pics"
                      :key="pic.index"
                      class="img_products"
                      :src="pic"

                  ></v-carousel-item>
                </v-carousel>
              </div>

              <div class="d-flex flex-column w-60 me-2 justify-content-center">
                <div class="">
                  <div class="d-flex p-3 bg-white rounded-4 border-costom justify-content-between  align-items-center">
                    <div class="overflow-hidden w-70">
                      <p :class="data_prod.name.length > 35 ? 'txtoverflow' : '' " class="m-0 d-flex font-bold font-4">
                        {{ data_prod.name }}</p>
                    </div>

                    <div v-if="data_prod.is_variable === 0 && data_prod.count == 0 "
                         class="animate__animated animate__fadeIn bg-unavailable rounded-5 d-flex p-2 align-items-center">
                      <img style="width: 15px" class="mx-2" src="../assets/img/add-to-cart.svg" alt="">
                      <p class="text-white font-5 px-2 m-0">
                        ناموجود
                      </p>
                    </div>

                    <div v-else-if="data_prod.is_variable === 0 && data_prod.order_count_select < 1"
                         @click="UpdateProduct(data_prod.name_store)"
                         class="animate__animated animate__fadeIn bg-green rounded-5 d-flex p-2 align-items-center">
                      <img style="width: 15px" class="mx-2" src="../assets/img/add-to-cart.svg" alt="">
                      <p class="text-white font-5 px-2 m-0">
                        خرید
                      </p>
                    </div>

                    <div v-else-if="data_prod.is_variable === 0 && data_prod.order_count_select > 0"
                         class="animate__animated animate__fadeIn w-25 d-flex align-items-center py-2 px-3 rounded-pill justify-content-between border-costom">

                      <img style="width: 15%;cursor: grab;" class="svg_inventory" src="../assets/img/add_green.svg"
                           alt=""
                           v-if="data_prod.count == -1 "
                           @click="data_prod.order_count_select++ ;UpdateProduct()">

                      <img style="width: 15%;cursor: grab;" class="svg_inventory" src="../assets/img/add_green.svg"
                           alt=""
                           @click="data_prod.order_count_select++ ;UpdateProduct()"
                           v-else-if="data_prod.order_count_select < data_prod.count">

                      <img style="width: 15%;cursor: grab;" class="svg_inventory" src="../assets/img/add_green.svg"
                           alt=""
                           v-else
                           @click="alerts('End of inventory')">

                      <p class="m-0">
                        <input class="w-100 ma-auto text-center" type="number" :value="data_prod.order_count_select"
                               @focusout="(event)=>{data_prod.order_count_select = Number(event.target.value) ; UpdateProduct()}">
                      </p>

                      <img style="width: 15%;cursor: grab;" class="svg_inventory" src="../assets/img/minus.svg" alt=""
                           @click="data_prod.order_count_select-- ;UpdateProduct()">
                    </div>
                  </div>
                </div>

                <div class="my-3">
                  <div class="d-flex p-3 bg-white rounded-4 border-costom justify-content-between align-items-center">
                    <div class="d-flex">
                      <p :class="data_prod.off_price === null ? 'font-color' : 'text-decoration-line-through' "
                         class="font-4 m-0">
                        {{ data_prod.price.toLocaleString() }}
                        <span v-if="data_prod.off_price == null">تومان</span>
                      </p>

                      <p v-if="data_prod.off_price !== null " class="d-flex font-color font-4 mx-3 m-0">
                        <span>{{ data_prod.off_price.toLocaleString() }}</span>
                        <span>تومان</span>
                      </p>
                    </div>

                    <div class="d-flex ">
                      <div v-if="data_prod.rating_product != null"
                           class="d-flex align-items-center bg-costom rounded-pill px-3 py-2">
                        <p class="m-0 font-5 mx-2">
                          {{ data_prod.rating_product }}
                        </p>

                        <img style="width: 15px" src="../assets/img/star_gold.svg" alt="">
                      </div>

                      <div v-if="data_prod.off_price != null"
                           class="d-flex align-items-center bg-costom rounded-pill mx-1 px-1 py-2">

                        <p class="m-0 mx-2 font-5 font-color">
                          <span>%</span>
                          <span>{{ data_prod.discount }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="">
                  <div class="p-3 bg-white rounded-4 border-costom d-flex align-items-center justify-content-between">
                    <div style="max-width: 50%" class="d-flex justify-content-end align-items-center my-1">
                      <img style="width: 20px" class="ml-1" src="../assets/img/shop.svg" alt="">

                      <div class="d-flex justify-content-end w-100">
                        <div class="overflow-hidden d-flex align-items-center">
                          <p class="font-4 mx-2 m-0 d-flex"
                             :class="data_prod.name_store.length > 35 ? 'txtoverflow' : '' ">{{data_prod.name_store }}</p>
                        </div>

                        <div v-if="data_prod.rating_store != null " class="position-relative">
                          <img style="height: 26px" src="../assets/img/star_gold.svg" alt="">
                          <p class="position-absolute m-0 font-5 text-white number_star">
                            {{ data_prod.rating_store }}
                          </p>
                        </div>
                      </div>
                    </div>

                    <router-link :to="{name:'StorePage',params:{unit_id:data_prod.unit_id}}"
                                 class="m-0 font-color text-decoration-none font-6">
                      برای مشاهده فروشگاه کلیک کنید
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-2">
              <div class="d-flex flex-column p-3 bg-white rounded-4 border-costom align-items-center">
                <p class="font-4 font-bold w-100">
                  توضیحات محصول :
                </p>
                <div class="w-100">
                  <p class="font-4 w-100 m-0">{{ data_prod.info }}</p>
                </div>
              </div>
            </div>

            <div v-if="data_prod.options.length != 0" class=" mb-2">
              <div class="p-3 bg-white rounded-4 border-costom">
                <p class="font-4 font-bold mb-5">ویژگی های محصول :</p>
                <div v-for="item in data_prod.options" :key="item.id" class="w-66 ma-auto">
                  <div class="d-flex justify-content-between p-1 ">
                    <p class="font-4 font-bold m-0"> {{ item.option_name }} :</p>
                    <p class="d-flex font-4 m-0">{{ item.value }}</p>
                  </div>
                  <hr>
                </div>
              </div>
            </div>

            <div v-if="data_prod.pdf_file != null " class=" mb-2">
              <a :href="data_prod.pdf_file" target="_blank"
                 class="text-decoration-none d-flex align-items-center justify-content-center bg-white rounded-4 px-2 py-4 position-relative">
                <div class="font-4 m-0 font-color font-bold">
                  محصول PDF دانلود
                </div>
                <img style="right:0;width: 72px;height: 50px" class="rounded-4 position-absolute"
                     src="../assets/img/download_icon.svg" alt="">
              </a>
            </div>

            <div v-if="data_prod.watch_link != null " class=" mb-2">
              <a :href="data_prod.watch_link" target="_blank"
                 class="text-decoration-none d-flex align-items-center  justify-content-center bg-white rounded-4 px-2 py-4 position-relative">
                <div class="font-4 m-0 font-color font-bold">
                  مشاهده ویدئو
                </div>
                <img style="right:0;width: 72px;height: 50px" class="rounded-4 position-absolute"
                     src="../assets/img/play_video.svg" alt="">
              </a>
            </div>
          </div>

          <div v-if="data_prod.is_variable === 1" class="animate__animated animate__fadeIn">
            <table class="w-100 text-center bg-white rounded-4">
              <thead class="font-4 bg-warning-subtle">
              <tr style="height: 3rem">
                <th>عکس</th>
                <th>کد محصول</th>
                <th>قیمت</th>
                <th>انتخاب</th>
              </tr>
              </thead>

              <tbody class="font-5">
              <tr v-for="(item , index) in data_prod.variable_item" :key="item.id" class="border-bottom" style="height: 5rem">
                <td><img @click="show_pic(index + 1)" class="img_variable rounded-3" :src="item.pic" alt=""></td>

                <td>{{ item.code }}</td>

                <td>{{ Number(item.price).toLocaleString() }}</td>

                <td style="height: 5rem" class="d-flex align-items-center justify-content-center">
                  <div v-if="item.count === 0 "
                       class="bg-unavailable m-auto w-50 rounded-5 d-flex p-2 align-items-center justify-content-center">
                    <img style="width: 15px" class="mx-2" src="../assets/img/add-to-cart.svg" alt="">
                    <p class="text-white font-5 px-2 m-0">
                      ناموجود
                    </p>
                  </div>

                  <div v-else-if="item.order_count_select < 1"
                       @click="UpdateProduct_variable(item.variable_id)"
                       class="bg-green rounded-5 d-flex p-2 align-items-center justify-content-center ms-2 w-50">
                    <img style="width: 15px" class="mx-2" src="../assets/img/add-to-cart.svg" alt="">
                    <p class="text-white font-5 px-2 m-0">
                      خرید
                    </p>
                  </div>

                  <div v-else-if="item.order_count_select > 0"
                       class="w-40 ms-2 d-flex py-2 px-3 rounded-pill justify-content-between border-costom">
                    <img style="width: 15px" class="svg_inventory" src="../assets/img/minus.svg" alt=""
                         @click="item.order_count_select--;UpdateProduct_variable(item.variable_id)">

                      <input type="number" class="font-4 w-70 text-center" :value="item.order_count_select"
                             @focusout="(event)=>{item.order_count_select = Number(event.target.value) ; UpdateProduct_variable(item.variable_id)}">

                    <img style="width: 15px" class="svg_inventory" src="../assets/img/add_green.svg" alt=""
                         @click="item.order_count_select++ ;UpdateProduct_variable(item.variable_id)"
                         v-if="item.order_count_select < item.count">

                    <img style="width: 15px" class="svg_inventory" src="../assets/img/add_green.svg" alt=""
                         v-else
                         @click="alerts('End of inventory')">
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>

      <div style="right: 0;width: 10%;height:calc(100vh - 8rem);" id="share_list_web"
           class="animate__animated animate__fadeIn position-fixed mr-5 d-flex flex-column justify-content-evenly align-items-center">

        <div @click="share_prod" class="item_share d-flex flex-column align-items-center p-3 mb-2">
          <img style="width: 1.5em" src="../assets/img/share_web.svg" alt="">
          <p class="m-0 font-6 text-center mt-2">
            اشتراک گذاری
          </p>
        </div>

        <div id="div_mark_web" @click="mark_prod('web')" class="item_share d-flex flex-column p-3 align-items-center mb-2">
          <img v-if="mark" style="width: 1.5em" src="../assets/img/save_mark_web.svg" alt="">
          <img v-else style="width: 1.5em" src="../assets/img/bookmark-white-web.svg" alt="">
          <p class="m-0 font-6 text-center mt-2">
            نشان کردن
          </p>
        </div>

        <router-link :to="{name:'CommentProducts',params:{prod_id:product_id , type:'product'}}"
                     class="item_share d-flex flex-column p-3 text-decoration-none align-items-center mb-2">
          <img style="width: 1.5em" src="../assets/img/comment-web.svg" alt="">
          <p class="m-0 font-6 text-center mt-2">
            نظرات محصول
          </p>
        </router-link>

        <div @click="comparison"
             class="item_share d-flex flex-column p-3 text-decoration-none align-items-center mb-2">
          <img style="width: 1.5em" src="../assets/img/change-web.svg" alt="">
          <p class="m-0 font-6 text-center mt-2">
            مقایسه محصول
          </p>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped>
.img_variable {
  width: 3.5rem;
  height: 3.5rem;
}

.alert {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 15;
  height: 100vh;
  position: fixed;
  top: 0;
  background-color: rgba(77, 81, 84, 0.45);
}

@media (max-height: 800px) {
  #share_list_web {
    font-size: 10px;
  }
}

.div_img_products {
  width: 100% !important;
  height: 20rem !important;
}

.img_products {
  width: 100% !important;
  height: 100% !important;
}

.number_star {
  left: 50%;
  top: 58%;
  transform: translate(-50%, -50%);
}

.div_orders {
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: 700px;
  padding: .8rem;
}

.div_orders > div{
  padding: .7rem;
}

.v-btn--icon .v-icon {
  background-color: white !important;
  border-radius: 50% !important;
}

.share_list {
  width: 4rem;
  height: 0px;
  overflow: hidden;
  transition: 0.5s;
}

.div_share {
  position: fixed;
  bottom: 13%;
  width: 100%;
  max-width: 500px;
}

.holder_navbar_share {
  position: fixed;
  bottom: 11%;
  transition: transform 0.5s ease-in-out;
  transform-origin: center center;
}

.clicked {
  transform: rotate(180deg);
}

#share_list {
  border-top-left-radius: 50px;
  border-top-right-radius: 50px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.item_share {
  width: 100%;
  transition: .5s;
  border-radius: 30px;
  padding: 2% 0;
  white-space: nowrap;
  overflow: visible;
  text-decoration: none;
  color: #e15900
}

.item_share:hover {
  background-color: #818285;
  color: white !important;
  outline: 1px solid #e15900;
}

</style>